<template>
  <div class="el-input-time">
    <el-select
      v-if="!this.fixUnit"
      v-model="timeUnitValue"
      placeholder="Select"
    >
      <el-option
        v-for="item in unitOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-input-number
      v-model="numberValue"
      :min="1"
      :max="maxValue"
      controls-position="right"
    />
    <span class="input-num-unit">
      {{ timeUnit === "월" ? "개월" : timeUnit }}
    </span>
  </div>
</template>

<script>
import isSameMonth from 'date-fns/is_same_month/index';
const DAY = 1,
  MONTH = 30,
  YEAR = 365;

export default {
  name: 'ElInputDay',
  props: {
    value: {},
    fixUnit: {}
  },
  data() {
    return {
      unitOptions: [
        {
          value: DAY,
          label: '일'
        },
        {
          value: MONTH,
          label: '월'
        },
        {
          value: YEAR,
          label: '년'
        }
      ],
      currentValue: 0,
      timeUnitValue: 1,
      numberValue: 1
    };
  },
  computed: {
    timeUnit() {
      return this.unitOptions.find(unit => unit.value === this.timeUnitValue)
        .label;
    },
    maxValue() {
      if (this.timeUnitValue === DAY) {
        return 365;
      } else if (this.timeUnitValue === MONTH) {
        return 12;
      }
      return 100;
    }
  },
  watch: {
    timeUnitValue(value) {
      this.currentValue = value * this.numberValue;
      if (this.currentValue > this.maxValue * value) {
        this.numberValue = 1;
        return;
      }
      this.$emit('input', this.currentValue);
    },
    numberValue(value) {
      this.currentValue = value * this.timeUnitValue;

      this.$emit('input', this.currentValue);
    },
    value: {
      immediate: true,
      handler(value) {
        if (value === this.currentValue) {
          return;
        }

        if (this.fixUnit) {
          this.numberValue = value / this.fixUnit;
          return (this.timeUnitValue = this.fixUnit);
        }

        if (value % YEAR === 0) {
          this.numberValue = value / YEAR;
          return (this.timeUnitValue = YEAR);
        }

        if (value % MONTH === 0) {
          this.numberValue = value / MONTH;
          return (this.timeUnitValue = MONTH);
        }

        this.numberValue = value / DAY;
        return (this.timeUnitValue = DAY);
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/element-custom/components/el-input-time.scss';
</style>
